export default __webpack_public_path__ + "static/media/logo.69296859.svg";